// Drop down menu accessibility script
document.addEventListener('DOMContentLoaded', () => {
  const navContent = document.querySelector('.nav__content');
  let lastTriggerButton = null;

  const getSubnavByButton = (btn) =>
    document.getElementById(btn.getAttribute('data-target'));

  const closeMenu = () => {
    if (!navContent) return;

    // Hide any open subnavs
    navContent.querySelectorAll('[aria-hidden="false"]').forEach(el => {
      el.setAttribute('aria-hidden', 'true');
    });

    // Update buttons
    navContent.querySelectorAll('.js-navSubnavButton').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Remove "open" state on the container if present
    navContent.classList.remove('nav__content--open');

    // Return focus to the button that opened the menu
    if (lastTriggerButton) {
      lastTriggerButton.focus({ preventScroll: true });
    }
  };

  // Keep aria-expanded in sync + remember which button opened the visible subnav
  const updateAriaExpanded = () => {
    if (!navContent) return;
    const navIsOpen = navContent.classList.contains('nav__content--open');

    navContent.querySelectorAll('.js-navSubnavButton').forEach(button => {
      const subnav = getSubnavByButton(button);
      const subnavVisible = subnav && subnav.getAttribute('aria-hidden') === 'false';
      const expanded = (navIsOpen && subnavVisible) ? 'true' : 'false';

      button.setAttribute('aria-expanded', expanded);

      // Track the current trigger if its subnav is visible
      if (expanded === 'true') lastTriggerButton = button;
    });
  };

  // Initial check
  updateAriaExpanded();

  // Observe changes in nav content
  const observer = new MutationObserver(updateAriaExpanded);
  if (navContent) {
    observer.observe(navContent, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  // ESC closes menu and returns focus to opener
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const isAnyOpen =
        navContent?.classList.contains('nav__content--open') ||
        navContent?.querySelector('[aria-hidden="false"]');
      if (isAnyOpen) {
        e.preventDefault();
        closeMenu();
      }
    }
  }, true);

  // When focus leaves the nav area (or open dropdown), close it
  if (navContent) {
    navContent.addEventListener('focusout', (e) => {
      const next = e.relatedTarget; // where focus is going
      const hasOpenSubnav = !!navContent.querySelector('[aria-hidden="false"]');
      if (hasOpenSubnav && (!next || !navContent.contains(next))) {
        closeMenu();
      }
    });

    // If subnavs are opened by clicking/pressing on buttons, record the trigger
    navContent.querySelectorAll('.js-navSubnavButton').forEach(btn => {
      btn.addEventListener('click', () => { lastTriggerButton = btn; }, { capture: true });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') lastTriggerButton = btn;
      });
    });
  }
});

// Basic Accessibility Enhancements
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('br, b').forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.header__top-hat.js-topHat p').forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });  
    document.querySelectorAll('.swiper-wrapper').forEach(element => {
      element.setAttribute('role', 'list');
    });
    document.querySelectorAll('.swiper-slide').forEach(element => {
      element.setAttribute('role', 'listitem');
    });
    document.querySelectorAll('.content-module__text__cta a').forEach(link => {
      link.setAttribute('aria-label', 'Shop now, handcrafted products by PORTA in collaboration with artisans.');
    });
    document.querySelectorAll('a[href="/collections/all-products"]').forEach(link => {
      link.setAttribute('aria-label', 'View All Products');
    });

    document.querySelectorAll('.product-tile__image').forEach(tile => {
  const pictures = tile.querySelectorAll('picture');
  const firstImg = pictures[0]?.querySelector('img');
  const secondImg = pictures[1]?.querySelector('img');

  if (!firstImg || !secondImg) return;

  // When first image is focused, hide second image
  firstImg.addEventListener('focus', () => {
    secondImg.style.opacity = '0';
  });

  // When second image is focused, make it fully visible
  secondImg.addEventListener('focus', () => {
    secondImg.style.opacity = '1';
  });

  // Optional: Reset second image opacity when focus is lost
  firstImg.addEventListener('blur', () => {
    secondImg.style.opacity = '';
  });
  secondImg.addEventListener('blur', () => {
    secondImg.style.opacity = '';
  });
});
  });

// adding warning to collection filters
document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('button#collection-sort-toggle');

  if (button) {
    const trimmedText = button.textContent.trim();
    button.setAttribute('aria-label', `${trimmedText}, the page will refresh when you select an option.`);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('button#collection-filter-toggle');

  if (button) {
    const trimmedText = button.textContent.trim();
    button.setAttribute('aria-label', `${trimmedText}, the page will refresh when you select an option.`);
  }
});


  // External Links Warning
  document.addEventListener('DOMContentLoaded', () => {
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');

    const excludedLinks = [
      'https://www.facebook.com/vivarawpets',
      'https://www.instagram.com/vivarawpets/',
      'https://www.tiktok.com/@vivarawpets'
    ];

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  handleExternalLinks();
});

// Email and phone number labels
document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  handleContactLinks();
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("h2.about__text__title, h1").forEach(el => {
    if (!el.textContent.trim()) el.remove();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("h1").forEach(el => {
    if (!el.textContent.trim()) el.remove();
  });
});
